import axios from 'axios';
import * as url from "../config/BackendConfig";


class MemberService {

    register = (data, lang='en') => {
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Authorization': null,
                'Content-Type': "application/json",
            },
        };

        const requestUrl = url.BACKEND_BASE_URL + url.REGISTER;
        return axios.post(requestUrl, data, config);
    };


    login = (data, lang='en') => {
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Authorization': null,
                'Content-Type': "application/json",
            },
        };

        const requestUrl = url.BACKEND_BASE_URL + url.LOGIN;
        return axios.post(requestUrl, data, config);
    };


    getDashboardCounters = (token, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.DASHBOARD_COUNTERS;
        return axios.get(reuquestUrl, config);
    };


    getDashboardTimeseries = (token, period, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
            params: { period },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.DASHBOARD_YIMESERIES;
        return axios.get(reuquestUrl, config);
    };


    getData = (token, memberId, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'backoffice',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.REGISTER + memberId + '/';
        return axios.get(reuquestUrl, config);
    };


    getNotifications = (token, filterParameter, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
            params: { filterType: filterParameter },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.NOTIFICATIONS;
        return axios.get(reuquestUrl, config);
    };


    updateNotification = (token, data, notificationUuid, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.NOTIFICATIONS + notificationUuid + '/';
        return axios.put(reuquestUrl, data, config);
    };


    readAllNotifications = (token, data, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.READ_ALL_NOTIFICATIONS;
        return axios.post(reuquestUrl, data, config);
    };


    deleteNotification = (token, notificationUuid, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.NOTIFICATIONS + notificationUuid + '/';
        return axios.delete(reuquestUrl, config);
    };


    update = (token, data, memberId, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.UPDATE_MEMBER + memberId + '/';
        return axios.put(reuquestUrl, data, config);
    };


    updatePhoto = (token, data, memberId, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "multipart/form-data",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.UPDATE_MEMBER + memberId + '/';
        return axios.put(reuquestUrl, data, config);
    };


    completeProfile = (token, data, memberId, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'backoffice',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.COMPLETE_PROFILE + memberId + '/';
        return axios.put(reuquestUrl, data, config);
    };


    changePassword = (token, data, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.CHANGE_PASSWORD;
        return axios.post(reuquestUrl, data, config);
    };


    predictMarket = (token, data, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.PREDICT_FIXTURE_MARKET;
        return axios.post(reuquestUrl, data, config);
    };


    getMyPredictions = (token, filters, lang) => {
        const searchFilters = filters.searchFilters;
        const pagination = filters.pagination;
        const limit = pagination.pageSize;
        const offset = pagination.pageSize * (pagination.currentPage - 1);
        const params = { ...searchFilters, offset: offset, limit: limit };

        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
            params: params,
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.MY_PREDICTIONS;
        return axios.get(reuquestUrl, config);
    };


    getMyRecentPredictions = (token, lang) => {
        const params = { offset: 0, limit: 5 };
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
            params: params,
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.MY_PREDICTIONS;
        return axios.get(reuquestUrl, config);
    };


    verifyEmail = (data, lang) => {
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.REGISTER;
        return axios.post(reuquestUrl, data, config);
    };


    confirmCode = (data, lang) => {
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.REGISTER;
        return axios.post(reuquestUrl, data, config);
    };


    delete = (token, memberId, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.REGISTER + memberId + '/';
        return axios.delete(reuquestUrl, config);
    };
    
}

const MemberServiceInstance = new MemberService();
export default MemberServiceInstance;